import { Link, useNavigate } from "react-router-dom";

const TermsAndConditions = () => {
  const navigate = useNavigate();

  const headingStyle = {
    color: "#1e3a8a",
    marginTop: "32px",
    marginBottom: "12px",
    fontSize: "1.35rem",
  };

  const paragraphStyle = {
    marginBottom: "16px",
    textAlign: "justify",
  };

  const listStyle = {
    paddingLeft: "22px",
    marginBottom: "18px",
  };

  return (
    <div
      className="container"
      style={{
        fontFamily: "Arial, sans-serif",
        lineHeight: 1.8,
        background: "#fff",
        color: "#333",
        padding: "48px",
        maxWidth: "900px",
        margin: "80px auto 40px",
        borderRadius: "12px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        border: "1px solid #e5e5e5",
      }}
    >
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        style={{
          padding: "10px 18px",
          background: "#2563eb",
          color: "#fff",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
          fontSize: "15px",
          fontWeight: 500,
          marginBottom: "30px",
        }}
      >
        ← Back
      </button>

      {/* Title */}
      <h1
        style={{
          color: "#1f2937",
          borderBottom: "3px solid #2563eb",
          paddingBottom: "12px",
          marginBottom: "20px",
        }}
      >
        Terms of Service
      </h1>

      {/* Effective Date */}
      <div
        style={{
          background: "#f3f4f6",
          padding: "16px 20px",
          borderRadius: "8px",
          marginBottom: "30px",
        }}
      >
        <p style={{ margin: 0 }}>
          <strong>Effective Date:</strong> 25 January 2026
        </p>
      </div>

      <h2 style={headingStyle}>1. Agreement to Terms</h2>
      <p style={paragraphStyle}>
        By accessing or using this platform, you acknowledge that you have read,
        understood, and agree to be bound by these Terms of Service, our{" "}
        <Link to="/privacypolicy">Privacy Policy</Link>, and our{" "}
        <Link to="/refund-policy">Refund Policy</Link>. If you do not agree to
        these terms, you should not use this platform.
      </p>

      <h2 style={headingStyle}>2. Authentication</h2>
      <p style={paragraphStyle}>
        Login is provided through Google Sign-In for the purpose of verifying
        your email address and authenticating your identity.
      </p>

      <h2 style={headingStyle}>3. Online Payments</h2>

<p style={paragraphStyle}>
  This online payment system is provided by the National Institute of
  Technology Calicut (NIT Calicut). NIT Calicut may update these terms from
  time to time and any changes will be effective immediately upon being set out
  here. Please ensure you are aware of the current terms. The country of
  domicile for NIT Calicut is India.
</p>

<p style={paragraphStyle}>
  Please read these terms carefully before using the online payment facility.
  Using the online payment facility on this platform indicates that you accept
  these terms. If you do not accept these terms, do not use this facility.
</p>

<p style={paragraphStyle}>
  All payments are subject to the following conditions:
</p>

<ul style={listStyle}>
  <li style={{ marginBottom: "8px" }}>
    The description of services available through this platform is specific to
    your requirements when you log in using your registered credentials.
    Normally, payment is required in advance (i.e., before you commence your
    activity).
  </li>

  <li style={{ marginBottom: "8px" }}>
    All fees quoted are in Indian Rupees (INR). NIT Calicut reserves the right
    to change the fees at any time.
  </li>

  <li style={{ marginBottom: "8px" }}>
    Your payment will normally reach the NIT Calicut account to which you are
    making a payment within two working days.
  </li>

  <li style={{ marginBottom: "8px" }}>
    We cannot accept liability for a payment not reaching the correct NIT
    Calicut account due to you quoting an incorrect account number or incorrect
    personal details. Neither can we accept liability if payment is refused or
    declined by the credit/debit card supplier for any reason.
  </li>

  <li style={{ marginBottom: "8px" }}>
    If the card supplier declines payment, NIT Calicut is under no obligation
    to bring this fact to your attention. You should check with your
    bank/credit/debit card supplier that payment has been deducted from your
    account.
  </li>

  <li style={{ marginBottom: "8px" }}>
    In no event will NIT Calicut be liable for any damages whatsoever arising
    out of the use, inability to use, or the results of use of this platform,
    any websites linked to this platform, or the materials or information
    contained at any or all such sites, whether based on warranty, contract,
    tort, or any other legal theory and whether or not advised of the
    possibility of such damages.
  </li>

  <li style={{ marginBottom: "8px" }}>
    All payments are also subject to our{" "}
    <Link to="/RefundPolicy">Refund Policy</Link>.
  </li>
</ul>
      <h2 style={headingStyle}>4. User Responsibilities</h2>

      <ul style={listStyle}>
        <li style={{ marginBottom: "8px" }}>
          Submit accurate personal, academic, and document information.
        </li>
        <li style={{ marginBottom: "8px" }}>
          Do not impersonate another individual.
        </li>
        <li style={{ marginBottom: "8px" }}>
          Do not upload forged, altered, or misleading documents.
        </li>
        <li style={{ marginBottom: "8px" }}>
          Use the platform only for its intended purposes.
        </li>
      </ul>

      <h2 style={headingStyle}>5. Document Handling</h2>

      <p style={paragraphStyle}>
        Uploaded documents are used solely for identity verification, academic
        verification, internship processing, and other administrative purposes.
      </p>

      <h2 style={headingStyle}>6. Data Use & Retention</h2>

      <p style={paragraphStyle}>
        User data is generally retained for up to <strong>3 years</strong> from
        the date of submission. Actual retention periods may vary depending on
        institutional, operational, or legal requirements.
      </p>

      <p style={paragraphStyle}>
        <em>
          We are not responsible for retrieving user data after the applicable
          retention period has expired.
        </em>
      </p>

      <h2 style={headingStyle}>7. Termination</h2>

      <p style={paragraphStyle}>
        We reserve the right to suspend or terminate access to the platform if a
        user violates these Terms, submits false information, or misuses the
        platform.
      </p>

      <h2 style={headingStyle}>8. Limitation of Liability</h2>

      <p style={paragraphStyle}>We shall not be liable for:</p>

      <ul style={listStyle}>
        <li style={{ marginBottom: "8px" }}>
          Internship selection decisions, offers, or rejections.
        </li>
        <li style={{ marginBottom: "8px" }}>
          Payment failures caused by banks or payment service providers.
        </li>
        <li style={{ marginBottom: "8px" }}>
          Delays in payment confirmation beyond our control.
        </li>
        <li style={{ marginBottom: "8px" }}>
          Loss of access to user data after the retention period.
        </li>
      </ul>

      <h2 style={headingStyle}>9. Changes to Terms</h2>

      <p style={paragraphStyle}>
        We may modify these Terms of Service from time to time. Continued use of
        the platform after any changes constitutes your acceptance of the
        updated Terms.
      </p>

      <h2 style={headingStyle}>10. Contact</h2>

      <div
        style={{
          marginTop: "10px",
          padding: "18px",
          background: "#eef6ff",
          borderLeft: "4px solid #2563eb",
          borderRadius: "8px",
        }}
      >
        <strong>Questions or Support?</strong>
        <br />
        📧 <strong>placement@nitc.ac.in</strong>
      </div>

      {/* Bottom Navigation */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "40px",
          paddingTop: "20px",
          borderTop: "1px solid #ddd",
          flexWrap: "wrap",
          gap: "12px",
        }}
      >
        <Link
          to="/privacypolicy"
          style={{
            textDecoration: "none",
            color: "#2563eb",
            fontWeight: 600,
          }}
        >
          ← Privacy Policy
        </Link>

        <Link
          to="/Refundpolicy"
          style={{
            textDecoration: "none",
            color: "#2563eb",
            fontWeight: 600,
          }}
        >
          Refund Policy →
        </Link>
      </div>
    </div>
  );
};

export default TermsAndConditions;
